import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { isEmpty, some } from 'lodash';
import { withStyles  } from '@mui/styles';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Checkbox from "@mui/material/Checkbox";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Grid from '@mui/material/Grid';
import {AttachMoney, DateRange, ExpandMore} from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import DataFees from './DataFees'
import { isDelivering } from "../../utils/adManagerHelpers";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";

const styles = theme => ({
  leftIcon: {
    marginRight: theme.spacing(2)
  },
  caption: {
    marginTop: 14,
    height: 12,
    color: theme.primary,
  },
  MuiInputLabel: {
    fontSize: 12
  }
});


class RatesandDates extends Component {

  constructor(props) {
    super(props);
    this.state = { isChecked: false };
  }

  getDates = (order, placement) => {
    let orderStart = !isEmpty(order) ? moment(order.start) : moment();
    orderStart = orderStart.format('YYYY-MM-DD');
    let orderEnd = !isEmpty(order) ? moment(order.end) : moment();
    orderEnd = orderEnd.format('YYYY-MM-DD');
    const start = moment(placement.start);
    const end = moment(placement.end);
    return {
      orderStart,
      orderEnd,
      start,
      end
    };
  };

  dateChange = name => date => {
    const { onChange } = this.props;
    const evt = {
      target: {
        name,
        value: date.format('YYYY-MM-DD')
      }
    };
    onChange(evt);
  };

  checkChange = () => {
    this.setState({ isChecked: !this.state.isChecked });
  }

  /**
   *   CPD, Flat Fee and CPV type determined by strat/sp table
   *   CPC/CPA only for Standard Order
   *   Programmatic Sponsorship has to be CPD
   *   Click tracker is only CPC
   */
  handleIoRateType = (rateTypes, orderType, placement) => {
    const { strategies, salesProducts } = this.props;
    let adjustedRateTypes = rateTypes;
    if (isEmpty(strategies) || isEmpty(salesProducts)) {
      adjustedRateTypes = adjustedRateTypes.filter(art => art.name !== 'CPV');
      return adjustedRateTypes;
    }
    if (!placement.StrategyId || !placement.SalesProductId) {
      adjustedRateTypes = adjustedRateTypes.filter(art => art.name !== 'CPV');
      return adjustedRateTypes;
    }
    const salesProduct = salesProducts.find(s => s.id === placement.SalesProductId) || '';
    if (salesProduct.name === 'MTR Click Tracker') {
      adjustedRateTypes = [{ id: 2, name: "CPC" }];
      return adjustedRateTypes;
    }
    const strategy = strategies.find(s => s.id === placement.StrategyId);
    const strategySalesProduct = strategy?.SalesProducts?.find(
      sp => sp.id === placement.SalesProductId
    );
    const flatFeeEligible = strategySalesProduct?.StrategySalesProducts?.flatFeeEligible;
    if (flatFeeEligible === false || flatFeeEligible === 0) {
      adjustedRateTypes = adjustedRateTypes.filter(art => art.name !== 'Flat Fee');
    }
    if (salesProduct.name !== 'Custom') {
      adjustedRateTypes = adjustedRateTypes.filter(art => art.name !== 'CPV');
      return adjustedRateTypes;
    }
    if (placement.lineItemType === 'SPONSORSHIP' && orderType === 'Programmatic') {
      adjustedRateTypes = [{ id: 4, name: "CPD" }];
      return adjustedRateTypes;
    }
    if (flatFeeEligible === false || flatFeeEligible === 0) {
      adjustedRateTypes = adjustedRateTypes.filter(art => art.name !== 'CPD' && art.name !== 'Flat Fee');
    }
    if (placement.lineItemType !== 'STANDARD' && orderType === 'Programmatic') {
      adjustedRateTypes = adjustedRateTypes.filter(art => art.name !== 'CPC' && art.name !== 'CPA');
    }
    if (!adjustedRateTypes.find(art => art.name === 'Flat Fee')) {
      adjustedRateTypes = adjustedRateTypes.filter(art => art.name !== 'CPV');
    }
    return adjustedRateTypes;
  };

  /**
   * Normally, just quantity
   * Used to calculate days for CPD, or Flat Fee that is sent to Ad Manager as CPD
   * @returns number of days including start and end dates
   */
  cpdQty = () => {
    const { placement } = this.props;
    if (placement.IoRateTypeId === 4 || (placement.IoRateTypeId === 5 && placement.lineItemType !== 'NOT AD MANAGER')) {
      const start = moment(placement.start).startOf('day');
      const end = moment(placement.end).startOf('day');
      return moment(end).diff(moment(start), 'days') + 1;
    } else if (placement.IoRateTypeId === 5) {
      placement.contractedQuantity = 1;
      return placement.contractedQuantity;
    } else {
      return placement.contractedQuantity;
    }
  };

  render() {
    const {
      classes,
      constants,
      placement,
      order,
      pkg,
      onChange,
      onAmountChange,
      errors
    } = this.props;

    const {
      isChecked
    } = this.state;

    const {
      orderStart,
      orderEnd,
      start,
      end
    } = this.getDates(order, placement);

    const dateRun = `${orderStart} to ${orderEnd}`;
    let rateTypesGivenLIType = [{ id: 1, name: 'CPM'} ];  // default until constants is instantiated
    if (constants && placement && order) {
      rateTypesGivenLIType = this.handleIoRateType(constants.ioRateTypes, order.orderType, placement);
      if (!some(rateTypesGivenLIType, placement.IoRateType)) {
        placement.IoRateType = null;
        placement.IoRateTypeId = null;
      }
    }
    const showEffRate = !!(placement.effectiveRate && placement.effectiveRate > 0.00);

    return (
      <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <DateRange className={classes.leftIcon} />
          <Typography variant="subtitle1">Dates</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3} direction="row">
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="Start Date"
                  fullWidth
                  value={start}
                  inputFormat="MM/DD/YYYY"
                  disabled={isDelivering(placement)}
                  onChange={this.dateChange('start')}
                  animateYearScrolling={false}
                  error={!!errors.start}
                  helperText={errors.start}
                  margin="normal"
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="End Date"
                  fullWidth
                  value={end}
                  inputFormat="MM/DD/YYYY"
                  onChange={this.dateChange('end')}
                  animateYearScrolling={false}
                  error={!!errors.end}
                  helperText={errors.end}
                  margin="normal"
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={2}>
              <TextField
                variant="standard"
                disabled
                value={dateRun}
                label="Order Dates"
                fullWidth
                margin="normal" />
            </Grid>
            <Grid item xs={2}>
              <TextField
                variant="standard"
                disabled
                value={placement.lineItemType}
                label="Line Item Type"
                fullWidth
                margin="normal" />
            </Grid>
            <Grid item xs={2}>
              <TextField
                variant="standard"
                disabled
                value={(order && order.Advertiser && order.Advertiser.countryCode === 'CDN') ? 'CAD' : 'USD'}
                label="Currency"
                fullWidth
                margin="normal" />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <AttachMoney className={classes.leftIcon} />
          <Typography variant="subtitle1">Rates & Fees</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3} direction="row">
            {!pkg && (
              <Grid item xs={4}>
                <TextField
                  variant="standard"
                  fullWidth
                  select
                  name="IoRateTypeId"
                  onChange={onAmountChange}
                  margin="normal"
                  label="Rate Type"
                  value={placement.IoRateTypeId}
                  error={!!errors.IoRateTypeId}
                  helperText={errors.IoRateTypeId}>
                  {rateTypesGivenLIType.map(type => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            {pkg && (
              <Grid item xs={4}>
                <TextField
                  variant="standard"
                  fullWidth
                  margin="normal"
                  label="Rate Type"
                  value={pkg.rateType}
                  disabled>
                </TextField>
              </Grid>
            )}
            {!pkg && (
              <Grid item xs={4}>
                <TextField
                  variant="standard"
                  name="ioRate"
                  value={placement.ioRate}
                  label="Rate"
                  onChange={onAmountChange}
                  error={!!errors.ioRate}
                  helperText={errors.ioRate}
                  fullWidth
                  margin="normal">
                </TextField>
              </Grid>
            )}
            {pkg && (
              <Grid item xs={4}>
                <TextField
                  variant="standard"
                  value={pkg.rate}
                  label="Rate"
                  disabled
                  fullWidth
                  margin="normal">
                </TextField>
              </Grid>
            )}
            {!pkg && (
            <Grid item xs={4}>
              <TextField
                variant="standard"
                name="contractedQuantity"
                disabled={placement.IoRateTypeId === 4 || placement.IoRateTypeId === 5}
                value={this.cpdQty()}
                label="Contracted Quantity"
                onChange={onAmountChange}
                error={!!errors.contractedQuantity}
                helperText={errors.contractedQuantity}
                fullWidth
                margin="normal" />
            </Grid>
            )}
            {pkg && (
              <Grid item xs={4}>
                <TextField
                  variant="standard"
                  value={pkg.contractedQuantity}
                  label="Contracted Quantity"
                  disabled
                  fullWidth
                  margin="normal" />
              </Grid>
            )}
            {placement.lineItemType === 'SPONSORSHIP' && placement.IoRateTypeId === 1 && (
              <>
                <Grid item xs={1}>
                  <FormControl variant="standard" className={classes.fullWidth} component="fieldset">
                    <FormLabel className={classes.MuiInputLabel}>Impression Limit</FormLabel>
                    <Checkbox
                      checked={isChecked || !!placement.impressionsLimit}
                      color="primary"
                      onChange={this.checkChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  { (isChecked || placement.impressionsLimit) &&
                  <TextField
                    variant="standard"
                    name="impressionsLimit"
                    value={placement.impressionsLimit > 0 ? placement.impressionsLimit : ''}
                    label={"enter limit"}
                    disabled={!isChecked && !placement.impressionsLimit}
                    onChange={onChange}
                    fullWidth
                    margin="normal" /> }
                </Grid>

              </>
            )}
            { (placement.lineItemType !== 'SPONSORSHIP' || placement.IoRateTypeId !== 1) && (
              <Grid item xs={4} />
            )}

            { showEffRate && (
              <Grid item xs={4}>
                <TextField
                  variant="standard"
                  name="effectiveRate"
                  value={placement.effectiveRate}
                  label="Effective Rate"
                  disabled
                  fullWidth
                  margin="normal" />
              </Grid>
            )}
            { !showEffRate && (
              <Grid item xs={4} />
            )}

            <Grid item xs={4}>
              <TextField
                variant="standard"
                disabled
                fullWidth
                name="totalContractAmount"
                value={placement.totalContractAmount}
                label="Total Contracted Amount"
                error={!!errors.totalContractAmount}
                helperText={errors.totalContractAmount}
                margin="normal" />
            </Grid>

            {order && order.orderType !== 'Programmatic' &&
            (
            <Grid item xs={6}>
              <TextField
                variant="standard"
                fullWidth
                select
                name="viewability"
                onChange={onChange}
                margin="normal"
                label="Viewability"
                value={placement.viewability}
                error={!!errors.viewability}
                helperText={errors.viewability}>
                {constants.viewabilityTypes.map(type => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            )}
            {order && order.orderType !== 'Programmatic' &&
            (
            <Grid item xs={6}>
              <DataFees
                dataFees={placement.DataFees}
                onChange={onChange}
              />
            </Grid>
            )}
            {!isEmpty(placement.CreativeProducts) &&
            placement.CreativeProducts.some(cp => cp.premiumAssociated) && (
            <Grid item xs={6}>
              <TextField
                variant="standard"
                name='creativePremiumPercent'
                value={placement.creativePremiumPercent || ''}
                label='Creative Premium(%)'
                onChange={onChange}
                error={!!errors.creativePremiumPercent}
                helperText={errors.creativePremiumPercent}
                fullWidth
                margin="normal" />
            </Grid>
              )}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
    );
  }
}

RatesandDates.defaultProps = {
  order: null,
  placement: null
};

RatesandDates.propTypes = {
  classes: PropTypes.object.isRequired,
  order: PropTypes.object,
  placement: PropTypes.object,
  strategies: PropTypes.array
};

export default withStyles(styles)(RatesandDates);
